import { BASE_URL } from "../context/FetchContext";

export function trackLandingEvent(name: string, count = 1): void {
  try {
    const key = String(name ?? "").trim();
    if (!key) return;
    const delta = Number(count ?? 1);
    if (!Number.isFinite(delta) || delta <= 0) return;

    const baseUrl = String(BASE_URL).replace(/\/+$/, "");
    const url = `${baseUrl}/landing/events?event=${encodeURIComponent(key)}${delta !== 1 ? `&count=${delta}` : ""}`;

    try {
      if (typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function") {
        const ok = navigator.sendBeacon(url);
        if (ok) return;
      }
    } catch {
      // Best-effort; fall back to fetch below.
    }

    fetch(url, {
      method: "POST",
      mode: "no-cors",
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Never break UI flows.
  }
}
